var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inertia-link',{attrs:{"href":_vm.route('customer.show.angebote', {'customer': _vm.company.id})}},[_vm._v("\n  "+_vm._s(_vm.company.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }